<template>
  <app-card no-padding class="text-white mb-4">
    <div
      id="carousel"
      class="carousel slide slider-container-custom"
      data-bs-interval="10000"
    >
      <div class="carousel-inner">
        <!-- Slide 1 -->
        <div class="carousel-item active">
          <slide-employee-portal />
        </div>

        <!-- Slide 2 -->
        <div class="carousel-item">
          <slide-service-desk />
        </div>

        <!-- Slide 3 -->
        <!-- <div class="carousel-item">
          <slide-cybersecurity-portal />
        </div> -->
      </div>

      <!-- Controls -->
      <div  class="custom-carousel-controls d-flex justify-content-between w-100">
        <button class="bg-transparent border-0" type="button" data-bs-target="#carousel" data-bs-slide="prev" aria-label="Anterior">
          <span class="carousel-control-prev-icon" aria-hidden="true" />
        </button>

        <button class="bg-transparent border-0" type="button" data-bs-target="#carousel" data-bs-slide="next" aria-label="Siguiente">
          <span class="carousel-control-next-icon" aria-hidden="true" />
        </button>
      </div>
    </div>
  </app-card>
</template>

<script>
import AppCard from '../app/AppCard.vue';

/** 
 * Important:
 * Cybersecurity content is temporarily hidden because the platform
 * has not been released yet and will remain disabled until further notice. 
*/
// import SlideCybersecurityPortal from './SlideCybersecurityPortal.vue';

import SlideEmployeePortal from './SlideEmployeePortal.vue';
import SlideServiceDesk from './SlideServiceDesk.vue';

export default {
  components: {
    AppCard,
    SlideEmployeePortal,
    SlideServiceDesk,
    // SlideCybersecurityPortal
  },

  mounted(){    
    const carousel = document.getElementById('carousel');    
    new window.bootstrap.Carousel(carousel).cycle();      
  }
};
</script>

<style>
.slider-container-custom .custom-carousel-controls {
  position: absolute;
  top: 43%;
}

.slider-container-custom .custom-carousel-controls span {
  width: 40px;
  height: 40px;
}

.slider-container-custom .carousel-item .container{
  height: 300px;
  padding-left: 40px;
  padding-right: 40px;
}

.slider-container-custom .title {
  font-size: clamp(30px, 3vw, 45px);
}

.slider-container-custom .subtitle {
  font-size: clamp(12px, 3vw, 24px);
  font-weight: 100;
}

@media (max-width: 1200px){
  .slider-container-custom .carousel-item .container{
    height: 480px;
  }
}
</style>